import React from "react";
import * as S from "./styles";

const PageWrapper = ({ children }) => {
  return <S.Wrapper>{children}</S.Wrapper>;
};

export default PageWrapper;
